module.exports = __webpack_public_path__ + "static/img/logos.fe791214.png";